import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

import { Card, CardContent, Typography, AppBar, Tabs, Tab } from '@material-ui/core';

import moment from 'moment'

import { paymentsRef, childrenRef, usersRef, eventsRef } from '../firebase';

const styles = theme => ({
    title: {
        paddingLeft: '2%',
        paddingRight: '5%',
        paddingTop: '2%',
        paddingBottom: '5rem',
    }
});

class Payments extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            received: [],
            donated: [],
            receivedLoading: true,
            donatedLoading: true,
            childrenFetching: false,
            loading: true,
            value: 0,
        }
    }

    componentWillMount() {
        const myId = this.props.myId;
        
        usersRef.doc(myId).get()
            .then(snapshot => {
                let email = snapshot.data().email;
                paymentsRef.where('email', '==', email).get()
                    .then((querySnapshot) => {
                        let donated = [];

                        querySnapshot.forEach((doc) => {
                            // doc.data() is never undefined for query doc snapshots
                            donated.push(doc.data());
                        });

                        paymentsRef.where('refId', '==', myId).get()
                            .then((receivedSnap) => {
                                let received = [];
                
                                receivedSnap.forEach((doc) => {
                                    // doc.data() is never undefined for query doc snapshots
                                    received.push(doc.data());
                                });
                
                                this.setState({
                                    donated,
                                    received
                                })

                                this.getAllData()
                            });
                    });
            })
        
    }

    getAllData = () => {
        const { donated, received } = this.state;

        let eventIds = []

        donated.forEach(payment => {
            if (!eventIds.includes(payment.eventId) && payment.id != '') {
                eventIds.push(payment.eventId)
            }
        })

        received.forEach(payment => {
            if (!eventIds.includes(payment.eventId) && payment.id != '') {
                eventIds.push(payment.eventId)
            }
        })

        let eventData = []
        let eventPromises = []

        eventIds.forEach(childId => {
            eventPromises.push(eventsRef.doc(childId).get())
        })

        if (eventIds.length > 0) {
            Promise.all(eventPromises)
                .then(res => {
                    res.forEach(event => {
                        eventData.push({
                            event: event.data(),
                            id: event.id
                        })
                    })

                    let eventids = [];

                    eventData.forEach(event => {
                        eventids.push(event.id);
                    })

                    this.setState({eventData, eventids})

                })

            let childIds = []


            donated.forEach(payment => {
                if (!childIds.includes(payment.childId) && payment.id != '') {
                    childIds.push(payment.childId)
                }
            })

            received.forEach(payment => {
                if (!childIds.includes(payment.childId) && payment.id != '') {
                    childIds.push(payment.childId)
                }
            })

            let childrenData = []
            let promises = []

            childIds.forEach(childId => {
                promises.push(childrenRef.doc(childId).get())
            })

            if (childIds.length > 0) {
                Promise.all(promises)
                    .then(res => {
                        res.forEach(child => {
                            childrenData.push({
                                child: child.data(),
                                id: child.id
                            })
                        })

                        let ids = [];

                        childrenData.forEach(child => {
                            ids.push(child.id);
                        })

                        let newDonated = []
                        let newReceived = []

                        const { donated, received, eventData, eventids } = this.state

                        donated.forEach(payment => {
                            var child 
                            var event
                            ids.forEach((id, index) => {
                                let tmp = childrenData[index]
                                if (payment.childId === id) {
                                    child = tmp.child
                                }
                            })

                            eventids.forEach((id, index) => {
                                let tmp = eventData[index]
                                if (payment.eventId === id) {
                                    event = tmp.event
                                }
                            })

                            newDonated.push({
                                child,
                                event,
                                payment
                            })
                        })

                        received.forEach(payment => {
                            var child
                            var event
                            ids.forEach((id, index) => {
                                let tmp = childrenData[index]
                                if (payment.childId === id) {
                                    child = tmp.child
                                }
                            })

                            eventids.forEach((id, index) => {
                                let tmp = eventData[index]
                                if (payment.eventId === id) {
                                    event = tmp.event
                                }
                            })

                            newReceived.push({
                                child,
                                event,
                                payment
                            })
                        })

                        /* received.forEach(payment => {
                            let child = childrenData[ids.indexOf(payment.childId)]
                            newReceived.push({
                                payment,
                                child
                            })
                        }) */

                        console.log(newDonated)
                        console.log(newReceived)

                        this.setState({
                            donated: newDonated,
                            received: newReceived,
                            childrenFetching: true,
                            loading: false
                        })
                    })

            }
        }
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };

    render() {
        const { classes } = this.props;

        /* if (this.state.data.length === 0) {
            return (
                <div className={classes.title}>
                    <h2>No payments yet yet</h2>
                </div>
            );
        } */

        if(this.state.loading) {
            return (
                <h2>Loading...</h2>
            );
        }

        var data

        this.state.value === 0 ? data = this.state.received : data = this.state.donated

        return (
            <div className={classes.title}>
                <h1>PAYMENTS</h1>
                <AppBar position="static">
                    <Tabs centered value={this.state.value} onChange={this.handleChange}>
                        <Tab label="Received" />
                        <Tab label="Given" />
                    </Tabs>
                </AppBar>
                {data.map((payment) =>
                    <Card style={{ paddingTop:'10px', paddingBottom:'10px' }} className={classes.card} >
                        <CardContent>
                            <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid spacing={0} container item xs={12} sm={9} md={10} lg={10} xl={10} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Grid item xs={12} sm={8} md={9} lg={9} xl={9}>
                                        <Typography variant='title' className={classes.cardDescription}>
                                            For {payment.child.firstName + ' ' + payment.child.lastName}
                                        </Typography>
                                        <Typography component="p" className={classes.cardDescription}>
                                            {this.state.value === 0 && 'From' + payment.payment.name}
                                        </Typography>
                                        <Typography component="p" className={classes.cardDescription}>
                                            At {payment.event.name}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3} lg={3} xl={3}>
                                        <Typography component="p" className={classes.cardDescription}>
                                            ${parseInt(payment.payment.amount, 10) / 100}
                                        </Typography>
                                        <Typography component="p" className={classes.cardDescription}>
                                            {moment(payment.payment.date).format('MM/DD/YYYY')}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card >
                )}
            </div>
        );
    }
}

Payments.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Payments);



// WEBPACK FOOTER //
// ./src/components/Payments.js